import { defineStore } from 'pinia';

export const useModulesStore = defineStore('modules', () => {
  const SALESSUPERVISION = 'SalesSupervision';
  const LOGISTICS = 'Logistics';
  const GENERAL = 'General';
  const TRANSACTIONS = 'Transactions';
  const MANAGERREPORTING = 'ManagerReporting';
  const CONFIGURATION = 'Configuration';
  const INSTORE = 'InStore';
  const TRADERSMANAGEMENT = 'TradersManagement';
  const RECEIVES = 'Receives';
  const SALES = 'Sales';
  const PICKING = 'Picking';
  const DOCUMENTSMANAGEMENT = 'DocumentsManagement';
  const TPTRADEPOLICYMANAGEMENT = 'TPTradePolicyManagement';
  const SEGMENTATION = 'Segmentation';
  const QUESTIONNAIRES = 'Questionnaires';
  const INVENTORY = 'Inventory';
  const COLLECTIONMANAGEMENT = 'CollectionManagement';
  const ROUTES = 'Routes';
  const PRICECOLLECTION = 'PriceCollection';
  const WRHOUSEMANAGEMENT = 'WrHouseManagement';
  const PRINTING = 'Printing';
  const USERSETUP = 'UserSetup';
  const GENERALGROUPING = 'GeneralGrouping';
  const REPRESENTATIVES = 'Representatives';

  return {
    SALESSUPERVISION,
    LOGISTICS,
    GENERAL,
    TRANSACTIONS,
    MANAGERREPORTING,
    CONFIGURATION,
    INSTORE,
    TRADERSMANAGEMENT,
    RECEIVES,
    SALES,
    PICKING,
    DOCUMENTSMANAGEMENT,
    TPTRADEPOLICYMANAGEMENT,
    SEGMENTATION,
    QUESTIONNAIRES,
    INVENTORY,
    COLLECTIONMANAGEMENT,
    ROUTES,
    PRICECOLLECTION,
    WRHOUSEMANAGEMENT,
    PRINTING,
    USERSETUP,
    GENERALGROUPING,
    REPRESENTATIVES,
  };
});
